import styled from "@emotion/styled";

export const DeleteFontStyle = styled.p`
  font-size: 24px;

  strong {
    color: red;
  }
`;
